module.exports = __webpack_public_path__ + "49acb12e4391cd319d7e041cab38d19c.svg";